import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    fr: {
      translation: {
        edition: "VOL. I — N°01 — ÉDITION 2026",
        bureau: {
          orb: "Le Conseil veille",
          greeting: {
            eyebrow: "Bureau privé",
            subDate: "Dimanche 24 mai MMXXVI · 21h47",
            hello: "Bonsoir",
            sub: "Le Conseil siège à votre demande. Trois dossiers archivés cette semaine, un porte-parole en attente de votre réponse.",
            metaTotal: "saisines au total",
            memberSince: "Membre depuis",
            active: "Actif",
          },
          section1: {
            num: "Section I — Nouvelle saisine",
            h2a: "Quelle question",
            h2b: "pour le",
            h2c: "Conseil",
            h2d: "aujourd'hui ?",
            lead: "Tapez votre question, choisissez un mode si vous le souhaitez — ou laissez le Conseil le détecter. Hōjin vous reçoit avant la délibération.",
          },
          saisine: {
            tag: "Office of the Board · Saisine N° MMXXVI·088 en préparation",
            h_a: "Présentez",
            h_b: "votre",
            h_c: "dossier.",
            sub: "Une phrase, une intention, un arbitrage — Hōjin s'occupe du reste avant que le Conseil ne siège.",
            placeholder: "Faut-il que je lève 500K€ en seed maintenant, ou attendre 6 mois ?",
            cta: "Saisir le Conseil",
            mode: "Mode",
          },
          section2: {
            num: "Section II — Dossiers récents",
            h2a: "Vos",
            h2b: "saisines.",
            lead: "Trois dossiers classés par dépôt. Cliquez pour rouvrir la délibération.",
            link: "Archives complètes →",
          },
          section3: {
            num: "Section III — Profil de décideur",
            h2a: "Qui",
            h2b: "vous êtes,",
            h2c: "aux yeux du Conseil.",
            lead: "Le Conseil tient compte de votre contexte à chaque saisine. Tenez-le à jour.",
            link: "Éditer mon profil →",
          },
          section4: {
            num: "Section IV — Activité",
            h2a: "Vos",
            h2b: "chiffres,",
            h2c: "depuis votre arrivée.",
            lead: "Le Conseil tient sa propre comptabilité — ce que vous lui avez demandé, ce que vous en avez fait.",
          },
          footer: {
            rights: "Tous droits réservés",
          },
        },
      },
    },
  },
  lng: "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export default i18n;
